"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _Plugin2 = _interopRequireDefault(require("../plugins/Plugin")),
    _Blockchains = require("../models/Blockchains"),
    PluginTypes = _interopRequireWildcard(require("../plugins/PluginTypes")),
    _SocketService = _interopRequireDefault(require("../services/SocketService")),
    _index = require("../index"),
    Desktop =
/*#__PURE__*/
function (a) {
  function b(a, c) {
    var d;
    return (0, _classCallCheck2.default)(this, b), d = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(b).call(this, _Blockchains.Blockchains.EOS, PluginTypes.WALLET_SUPPORT)), d.name = "ScatterSockets", d.context = a, d.holderFns = c, d;
  }

  return (0, _inherits2.default)(b, a), (0, _createClass2.default)(b, [{
    key: "connect",
    value: function d(a) {
      var b = this,
          c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
      return new Promise(function (d) {
        if (!a || !a.length) throw new Error("You must specify a name for this connection");
        c = Object.assign({
          initTimeout: 1e4,
          linkTimeout: 3e4
        }, c), _SocketService.default.init(a, c.linkTimeout), _SocketService.default.link().then(
        /*#__PURE__*/
        function () {
          var a = (0, _asyncToGenerator2.default)(
          /*#__PURE__*/
          _regenerator.default.mark(function a(c) {
            return _regenerator.default.wrap(function (a) {
              for (;;) {
                switch (a.prev = a.next) {
                  case 0:
                    if (c) {
                      a.next = 2;
                      break;
                    }

                    return a.abrupt("return", !1);

                  case 2:
                    return b.holderFns.get().isExtension = !1, b.holderFns.get().wallet || (b.holderFns.get().wallet = b.name), a.abrupt("return", d(!0));

                  case 5:
                  case "end":
                    return a.stop();
                }
              }
            }, a, this);
          }));
          return function () {
            return a.apply(this, arguments);
          };
        }());
      });
    }
  }, {
    key: "runAfterInterfacing",
    value: function () {
      var a = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function a() {
        var b = this;
        return _regenerator.default.wrap(function (a) {
          for (;;) {
            switch (a.prev = a.next) {
              case 0:
                return this.holderFns.get().addEventHandler(function (a, c) {
                  return b.eventHandler(a, c);
                }, "internal"), a.next = 3, this.holderFns.get().getIdentityFromPermissions();

              case 3:
                return this.holderFns.get().identity = a.sent, a.abrupt("return", !0);

              case 5:
              case "end":
                return a.stop();
            }
          }
        }, a, this);
      }));
      return function b() {
        return a.apply(this, arguments);
      };
    }()
  }, {
    key: "methods",
    value: function d() {
      var a,
          b = this,
          c = function c(a, _c) {
        // if(forget) SocketService.removeAppKeys();
        return (a || _c) && (b.holderFns.get().identity = a), _c || a;
      };

      return a = {}, (0, _defineProperty2.default)(a, _index.WALLET_METHODS.disconnect, function () {
        return _SocketService.default.disconnect();
      }), (0, _defineProperty2.default)(a, _index.WALLET_METHODS.isConnected, function () {
        return _SocketService.default.isConnected();
      }), (0, _defineProperty2.default)(a, _index.WALLET_METHODS.isPaired, function () {
        return _SocketService.default.isPaired();
      }), (0, _defineProperty2.default)(a, _index.WALLET_METHODS.addEventHandler, function (a) {
        var b = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : null;
        return _SocketService.default.addEventHandler(a, b);
      }), (0, _defineProperty2.default)(a, _index.WALLET_METHODS.removeEventHandler, function () {
        var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : null;
        return _SocketService.default.removeEventHandler(a);
      }), (0, _defineProperty2.default)(a, _index.WALLET_METHODS.listen, function (a) {
        return _SocketService.default.addEventHandler(a);
      }), (0, _defineProperty2.default)(a, _index.WALLET_METHODS.getVersion, function () {
        return _SocketService.default.sendApiRequest({
          type: "getVersion",
          payload: {}
        });
      }), (0, _defineProperty2.default)(a, _index.WALLET_METHODS.getIdentity, function (a) {
        return _SocketService.default.sendApiRequest({
          type: "getOrRequestIdentity",
          payload: {
            fields: a ? a : {
              accounts: [b.holderFns.get().network]
            }
          }
        }).then(c);
      }), (0, _defineProperty2.default)(a, _index.WALLET_METHODS.getIdentityFromPermissions, function () {
        return _SocketService.default.sendApiRequest({
          type: "identityFromPermissions",
          payload: {}
        }).then(c);
      }), (0, _defineProperty2.default)(a, _index.WALLET_METHODS.forgetIdentity, function () {
        return _SocketService.default.sendApiRequest({
          type: "forgetIdentity",
          payload: {}
        }).then(function (a) {
          return c(null, a);
        });
      }), (0, _defineProperty2.default)(a, _index.WALLET_METHODS.updateIdentity, function (a) {
        var b = a.name,
            d = a.kyc;
        return _SocketService.default.sendApiRequest({
          type: "updateIdentity",
          payload: {
            name: b,
            kyc: d
          }
        }).then(function (a) {
          return a ? c(a) : null;
        });
      }), (0, _defineProperty2.default)(a, _index.WALLET_METHODS.authenticate, function (a) {
        var b = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : null,
            c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
        return _SocketService.default.sendApiRequest({
          type: "authenticate",
          payload: {
            nonce: a,
            data: b,
            publicKey: c
          }
        });
      }), (0, _defineProperty2.default)(a, _index.WALLET_METHODS.getArbitrarySignature, function (a, b) {
        return _SocketService.default.sendApiRequest({
          type: "requestArbitrarySignature",
          payload: {
            publicKey: a,
            data: b
          }
        });
      }), (0, _defineProperty2.default)(a, _index.WALLET_METHODS.getPublicKey, function (a) {
        return _SocketService.default.sendApiRequest({
          type: "getPublicKey",
          payload: {
            blockchain: a
          }
        });
      }), (0, _defineProperty2.default)(a, _index.WALLET_METHODS.linkAccount, function (a, c) {
        return _SocketService.default.sendApiRequest({
          type: "linkAccount",
          payload: {
            account: a,
            network: c || b.holderFns.get().network
          }
        });
      }), (0, _defineProperty2.default)(a, _index.WALLET_METHODS.hasAccountFor, function (a) {
        return _SocketService.default.sendApiRequest({
          type: "hasAccountFor",
          payload: {
            network: a || b.holderFns.get().network
          }
        });
      }), (0, _defineProperty2.default)(a, _index.WALLET_METHODS.suggestNetwork, function (a) {
        return _SocketService.default.sendApiRequest({
          type: "requestAddNetwork",
          payload: {
            network: a || b.holderFns.get().network
          }
        });
      }), (0, _defineProperty2.default)(a, _index.WALLET_METHODS.requestTransfer, function (a, c, d) {
        var e = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {};
        return _SocketService.default.sendApiRequest({
          type: "requestTransfer",
          payload: {
            network: a || b.holderFns.get().network,
            to: c,
            amount: d,
            options: e
          }
        });
      }), (0, _defineProperty2.default)(a, _index.WALLET_METHODS.requestSignature, function (a) {
        return _SocketService.default.sendApiRequest({
          type: "requestSignature",
          payload: a
        });
      }), (0, _defineProperty2.default)(a, _index.WALLET_METHODS.createTransaction, function (a, c, d, e) {
        return _SocketService.default.sendApiRequest({
          type: "createTransaction",
          payload: {
            blockchain: a,
            actions: c,
            account: d,
            network: e || b.holderFns.get().network
          }
        });
      }), (0, _defineProperty2.default)(a, _index.WALLET_METHODS.addToken, function (a, c) {
        return _SocketService.default.sendApiRequest({
          type: "addToken",
          payload: {
            token: a,
            network: c || b.holderFns.get().network
          }
        });
      }), a;
    }
  }, {
    key: "eventHandler",
    value: function () {
      var a = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function a(b) {
        return _regenerator.default.wrap(function (a) {
          for (;;) {
            switch (a.prev = a.next) {
              case 0:
                a.t0 = b, a.next = a.t0 === _index.EVENTS.Disconnected ? 3 : a.t0 === _index.EVENTS.LoggedOut ? 5 : 9;
                break;

              case 3:
                return this.holderFns.get().identity = null, a.abrupt("break", 9);

              case 5:
                return a.next = 7, this.holderFns.get().getIdentityFromPermissions();

              case 7:
                return this.holderFns.get().identity = a.sent, a.abrupt("break", 9);

              case 9:
              case "end":
                return a.stop();
            }
          }
        }, a, this);
      }));
      return function b() {
        return a.apply(this, arguments);
      };
    }()
  }]), b;
}(_Plugin2.default);

exports.default = Desktop;